// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/entity/image.proto (package carmen, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_proto_model_core_date } from "../core/date_pb";

/**
 * Describes the file proto/model/entity/image.proto.
 */
export const file_proto_model_entity_image = /*@__PURE__*/
  fileDesc("Ch5wcm90by9tb2RlbC9lbnRpdHkvaW1hZ2UucHJvdG8SBmNhcm1lbiItChBJbWFnZUF0dHJpYnV0aW9uEgwKBG5hbWUYASABKAkSCwoDdXJsGAIgASgJInQKBUltYWdlEgsKA3VybBgBIAEoCRIPCgdjYXB0aW9uGAIgASgJEh0KB2NyZWF0ZWQYAyABKAsyDC5jYXJtZW4uRGF0ZRIuCgxhdHRyaWJ1dGlvbnMYBCADKAsyGC5jYXJtZW4uSW1hZ2VBdHRyaWJ1dGlvbiJOCg1JbWFnZUNhcm91c2VsEh0KBmltYWdlcxgBIAMoCzINLmNhcm1lbi5JbWFnZRINCgV0aXRsZRgCIAEoCRIPCgdjYXB0aW9uGAMgASgJQihaJmdpdGh1Yi5jb20veXVuYWNhYmEvY2FybWVuL3Byb3RvL21vZGVsYgZwcm90bzM", [file_proto_model_core_date]);

/**
 * Describes the message carmen.ImageAttribution.
 * Use `create(ImageAttributionSchema)` to create a new message.
 */
export const ImageAttributionSchema = /*@__PURE__*/
  messageDesc(file_proto_model_entity_image, 0);

/**
 * Describes the message carmen.Image.
 * Use `create(ImageSchema)` to create a new message.
 */
export const ImageSchema = /*@__PURE__*/
  messageDesc(file_proto_model_entity_image, 1);

/**
 * Describes the message carmen.ImageCarousel.
 * Use `create(ImageCarouselSchema)` to create a new message.
 */
export const ImageCarouselSchema = /*@__PURE__*/
  messageDesc(file_proto_model_entity_image, 2);

